import React from 'react';
import UserData from './UserData';
import SubscriptionInfo from './SubscriptionInfo';
import ChangePasswordModal from './ChangePasswordModal';
import EditProfileModal from './EditProfileModal';
import styles from './MyAccount.module.css';
import { Helmet } from 'react-helmet';
import { useUserProfile } from '../../hooks/useUserProfile';

const ProfilePage = () => {
  const [showPasswordModal, setShowPasswordModal] = React.useState(false);
  const [showEditModal, setShowEditModal] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState('profile');
  const { userData } = useUserProfile();

  return (
    <>
    <Helmet>
      <title>My Profile - SunoKahaniyan</title>
      <meta name="description" content="View and manage your profile information and subscription on SunoKahaniyan." />
    </Helmet>
    <div className={styles.container}>
      <div className={styles.profileCard}>
        <h1 className={styles.title}>My Account</h1>
        
        {/* Tab Navigation */}
        <div className={styles.tabNavigation}>
          <button 
            className={`${styles.tabButton} ${activeTab === 'profile' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('profile')}
          >
            Profile
          </button>
          <button 
            className={`${styles.tabButton} ${activeTab === 'subscription' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('subscription')}
          >
            Subscription
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === 'profile' ? (
          <>
            <UserData />
            <div className={styles.buttonGroup}>
              <button 
                className={styles.editProfileBtn}
                onClick={() => setShowEditModal(true)}
              >
                Edit Profile
              </button>
              <button 
                className={styles.changePasswordBtn}
                onClick={() => setShowPasswordModal(true)}
              >
                Change Password
              </button>
            </div>
          </>
        ) : (
          <SubscriptionInfo />
        )}
      </div>

      {showEditModal && (
        <EditProfileModal 
          onClose={() => setShowEditModal(false)} 
          userData={userData?.user}
        />
      )}

      {showPasswordModal && (
        <ChangePasswordModal onClose={() => setShowPasswordModal(false)} />
      )}
    </div>
    </>
  );
};

export default ProfilePage;